import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-16 md:py-24 px-4 bg-card/30 border-y border-white/5 relative" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-70">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm mb-10 text-center" data-id="element-71">
            ¿Te suena familiar?
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-muted leading-relaxed font-light" data-id="element-72">
            <p data-id="element-73">
              Apoyás la cabeza en la almohada a las 2 AM, pero tu cerebro decide
              que es el momento perfecto para repasar esa planilla de Excel, la
              deuda que vence mañana o ese comentario que te hizo tu jefe a las
              10 de la mañana.
            </p>

            <div className="pl-6 border-l-2 border-warm/40 py-2 space-y-4 my-8" data-id="element-74">
              <p data-id="element-75">Sentís los latidos en el cuello.</p>
              <p data-id="element-76">Una presión en el pecho que no te deja respirar hondo.</p>
              <p data-id="element-77">
                Las manos te tiemblan un poco mientras hacés scroll infinito en
                TikTok intentando "distraerte", pero solo lográs despertarte
                más.
              </p>
            </div>

            <p className="text-2xl md:text-3xl font-serif text-main mt-16 mb-10" data-id="element-78">
              <span className="text-warm font-bold" data-id="element-79">No es tu culpa.</span>
            </p>

            <p className="bg-warm/10 p-6 rounded-xl border border-warm/20 text-main" data-id="element-80">
              Tu sistema de alarma biológico se quedó trabado en el modo{' '}
              <span className="italic" data-id="element-81">"supervivencia"</span> y no sabés dónde
              está el botón de apagado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}